import {
  SocialsChallengeInvitationsClient,
  ChallengeInvitationList,
  ChallengeInvitation,
  CreateChallengeInvitationDto,
} from "@nestcoinco/hyper-api-gateway-api-client";

import apiConfig from "../config/api-config";
import { axiosInstance } from "../config/axios-instance";

const socialsChallengesInvitationsClient =
  new SocialsChallengeInvitationsClient(apiConfig, undefined, axiosInstance);

const handleGetChallengeInvitationDetails = async (inviteId: string) => {
  try {
    const { data } =
      await socialsChallengesInvitationsClient.getInvitationDetail(inviteId);
    return data;
  } catch {
    return;
  }
};

const handleGetMyChallengeInvitations = async ({
  page,
  limit,
  sort,
}: {
  page?: number;
  limit?: number;
  sort?: string;
} = {}): Promise<ChallengeInvitationList> => {
  return (
    await socialsChallengesInvitationsClient.getMyInvitations(page, limit, sort)
  ).data;
};

const handleCreateChallengeInvitation = async (
  createChallengeInvitationDto?: CreateChallengeInvitationDto
): Promise<ChallengeInvitation> => {
  return (
    await socialsChallengesInvitationsClient.createChallengeInvitation(
      createChallengeInvitationDto
    )
  ).data;
};

export {
  handleGetChallengeInvitationDetails,
  handleGetMyChallengeInvitations,
  handleCreateChallengeInvitation,
};
